<template>
  <div
    class="fixed-flex"
    :style="{ height }"
    :class="topClasses"
  >
    <div class="top-fixed">
      <slot name="top" />
    </div>

    <div class="bottom-content-wrapper">
      <slot name="bottom" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    top: {
      type: Object,
      default: null
    },
    topOffset: {
      type: Number,
      default: null
    },
  },

  computed: {
    topClasses() {
      return {
        consumeAllAvailableSpace: this.top.consumeAllAvailableSpace
          ? this.top.consumeAllAvailableSpace
          : true,
      };
    },

    height() {
      if (!this.topOffset) {
        return `100%`;
      } else {
        return `calc(100% - ${this.topOffset}px)`;
      }
    },
  },

  created() {
    console.log('top', top.consumeAllAvailableSpace);
  },
};
</script>


<style scoped lang="scss">
// https://codepen.io/sulfurious/pen/eWPBjY?editors=1100

.fixed-flex {
  display: flex;
  flex-direction: column;

  .top-fixed {
    overflow: hidden;

    .consumeAllAvailableSpace {
      flex: 1;
    }
  }

  .bottom-content-wrapper {
    display: flex;
    flex: 1;
    min-height: 0px;
  }
}
</style>